// Sincroniza todos los registros del nuevo modelo hacia el modelo LEGACY,
// reutilizando la misma lógica de migración que "apply" y "asignar postulante".
//
//   POST {APPLICANT}/application/sync?userId=<id>
//   → { message, total, migrated, failed, failedIds }
//
// Se dispara desde el botón oculto "Sincronizar registros" de la tabla de
// Postulaciones (revelado tras 20 clics en el logo).

export interface ISyncRegistrosResult {
  message: string;
  total: number;
  migrated: number;
  failed: number;
  failedIds?: string[];
}

export const syncRegistros = async (): Promise<ISyncRegistrosResult> => {
  const userId = sessionStorage.getItem("usuarioId") ?? "";
  const baseUrl = process.env.REACT_APP_API_APPLICANT;
  if (!baseUrl) throw new Error("Configuración faltante: REACT_APP_API_APPLICANT.");

  const res = await fetch(
    `${baseUrl}/application/sync?userId=${encodeURIComponent(userId)}`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    }
  );

  if (!res.ok) {
    throw new Error(`HTTP ${res.status}`);
  }

  return (await res.json()) as ISyncRegistrosResult;
};
